<div class="table-container mat-elevation-z2 mx-1 mt-4">
  <div class="row justify-between align-center" style="padding: 1em">
    <!-- Filtros -->
    <app-filtro-tabla
      class="flex-1"
      [datos]="[vecino, cliente, tipoOperacion, estado, fecha]"
      [search]="search"
      (onFilterChange)="cambioFiltro($event)"
    />
    <!-- Actualizar -->
    <button
      mat-icon-button
      color="primary"
      matTooltip="Actualizar"
      (click)="actualizar()"
    >
      <mat-icon>refresh</mat-icon>
    </button>
    <!-- Columnas -->
    <app-column-select
      [(columns)]="columnas"
      [columnNames]="nombreColumnas"
      [saveName]="saveColumnas"
    />
  </div>

  @if (loading) {
    <mat-progress-bar mode="indeterminate" />
  }

  <!-- Pagination -->
  <mat-paginator
    [length]="totalCount"
    [pageSize]="helper.pageSize"
    [pageSizeOptions]="helper.pageSizeOptions"
    [showFirstLastButtons]="true"
    (page)="pageEvent($event)"
  />

  <!-- Tabla -->
  <mat-table
    [dataSource]="dataSource"
    matSort
    (matSortChange)="sortChange($event)"
  >
    <!-- Columna fechaCreacion -->
    <ng-container matColumnDef="fechaCreacion">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        Fecha
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Fecha:</span>
        {{ row.fechaCreacion | date: "dd/MM/yyyy HH:mm:ss" }}
      </mat-cell>
    </ng-container>

    <!-- Columna cliente -->
    <ng-container matColumnDef="cliente">
      <mat-header-cell *matHeaderCellDef mat-sort-header="idCliente">
        Cliente
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Cliente:</span>
        {{ clienteNombre(row.idCliente) }}
      </mat-cell>
    </ng-container>

    <!-- Columna tipoOperacion -->
    <ng-container matColumnDef="tipoOperacion">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        Operación
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Operación:</span>
        {{ row.tipoOperacion === "alta_vecino" ? "Alta de vecino" : "Alerta" }}
      </mat-cell>
    </ng-container>

    <!-- Columna metodoAPI -->
    <ng-container matColumnDef="metodoAPI">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        Método API
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Método API:</span>
        <span class="mono">{{ row.metodoAPI }}</span>
      </mat-cell>
    </ng-container>

    <!-- Columna vecino -->
    <ng-container matColumnDef="vecino">
      <mat-header-cell *matHeaderCellDef> Vecino </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Vecino:</span>
        {{ row.requestBody?.label }}
      </mat-cell>
    </ng-container>

    <!-- Columna trackingid -->
    <ng-container matColumnDef="trackingid">
      <mat-header-cell *matHeaderCellDef> Tracking ID </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Tracking ID:</span>
        <span class="mono">{{ row.requestBody?.trackingid }}</span>
      </mat-cell>
    </ng-container>

    <!-- Columna estado -->
    <ng-container matColumnDef="estado">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        Estado
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Estado:</span>
        <span class="estado" [ngClass]="row.estado">{{ row.estado }}</span>
      </mat-cell>
    </ng-container>

    <!-- Columna responseStatus -->
    <ng-container matColumnDef="responseStatus">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        HTTP
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">HTTP:</span>
        {{ row.responseStatus ?? "-" }}
      </mat-cell>
    </ng-container>

    <!-- Columna intentos -->
    <ng-container matColumnDef="intentos">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        Intentos
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Intentos:</span>
        {{ row.intentos }}
      </mat-cell>
    </ng-container>

    <!-- Columna duracionMs -->
    <ng-container matColumnDef="duracionMs">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        Duración
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Duración:</span>
        {{ row.duracionMs != null ? row.duracionMs + " ms" : "-" }}
      </mat-cell>
    </ng-container>

    <!-- Columna acciones -->
    <ng-container matColumnDef="acciones">
      <mat-header-cell *matHeaderCellDef> Acciones </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Acciones:</span>
        <button
          mat-icon-button
          color="accent"
          (click)="verDetalle(row)"
          matTooltip="Ver request y respuesta"
        >
          <mat-icon>visibility</mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="columnas; sticky: true" />
    <mat-row *matRowDef="let row; columns: columnas" />
  </mat-table>

  <!-- Pagination -->
  <mat-paginator
    [length]="totalCount"
    [pageSize]="helper.pageSize"
    [pageSizeOptions]="helper.pageSizeOptions"
    [showFirstLastButtons]="true"
    (page)="pageEvent($event)"
  />
</div>
